import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SidebarService, SidebarMenu, LayoutService } from '@core/features';
import { ToastModule } from 'primeng/toast';
import { ApiUserService } from '@core/services';
import { UserService } from 'projects/core/src/lib/services/user/user.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [CommonModule, RouterOutlet, ToastModule],
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    title = 'authentication';

    constructor(
        private sidebarService: SidebarService,
        private layoutService: LayoutService,
        private apiUserService: ApiUserService,
        private userService: UserService,
    ) {}

    async ngOnInit(): Promise<void> {
        // Cargar el perfil del usuario al inicializar la aplicación
        try {
            const profileData = await this.apiUserService.getProfile();
            if (profileData && profileData['hydra:member'] && profileData['hydra:member'][0]) {
                const userData = profileData['hydra:member'][0];
                this.userService.saveUser(userData);
                console.log('[Admin] Perfil de usuario cargado:', userData);
            }
        } catch (error) {
            console.error('[Admin] Error al cargar perfil de usuario:', error);
        }

        const menuItems: SidebarMenu = {
            logo: 'assets/logo-cloudmefy-azul.svg',
            mobile_logo: 'assets/logo-cloudmefy-azul-v.svg',
            app: 'Administración',
            main: {
                name: 'menu incial',
                navigation: [
                    {
                        id: 1,
                        name: 'Aplicaciones',
                        iconify: 'icon-[ph--app-window]',
                        route: '/applications',
                    },
                    {
                        id: 1,
                        name: 'Usuarios',
                        iconify: 'icon-[ph--users-light]',
                        route: '/users',
                        admin: true,
                        gestion_usuarios: true,
                    },
                    {
                        id: 1,
                        name: 'Empresa',
                        iconify: 'icon-[mdi--company]',
                        route: '/company/list',
                        admin: true,
                    },
                    {
                        id: 1,
                        name: 'Proyectos',
                        iconify: 'icon-[mdi--vector-polyline]',
                        route: '/projects/list',
                        admin: true,
                    },

                    {
                        id: 1,
                        name: 'Sistemas',
                        iconify: 'icon-[mdi--chart-tree]',
                        route: '/sistemas/list',
                        admin: true,
                    },

                    {
                        id: 6,
                        name: 'Paquetes de Trabajo',
                        iconify: 'icon-[mdi--package-variant-closed]',
                        route: '/paquetes-trabajo/list',
                        admin: true,
                    },

                    {
                        id: 1,
                        name: 'Tags',
                        iconify: 'icon-[mdi--tag-outline]',
                        route: '/tags/list',
                        admin: true,
                    },
                    {
                        id: 1,
                        name: 'Plantas',
                        iconify: 'icon-[mdi--factory]',
                        route: '/plantas/list',
                        admin: true,
                    },
                    {
                        id: 5,
                        name: 'Especialidad',
                        iconify: 'icon-[oui--app-index-pattern]',
                        route: '/especialidad/',
                        admin: true,
                    },
                ],
            },
            user: {
                name: 'Cloudmefy',
                function: '',
                email: '',
                role: '',
                image: 'https://ui-avatars.com/api/?background=random&name=P',
                navigation: [
                    {
                        id: 1,
                        name: 'Cloudmefy',
                        route: '/dashboard',
                    },
                ],
            },
        };

        this.layoutService.setShowProject(false);
        this.sidebarService.setUpMenuAdmin(menuItems);
    }
}
